import { render } from "./admin-user.vue?vue&type=template&id=16d06b0e&scoped=true"
import script from "./admin-user.vue?vue&type=script&lang=js"
export * from "./admin-user.vue?vue&type=script&lang=js"

import "./admin-user.vue?vue&type=style&index=0&id=16d06b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d06b0e"]])

export default __exports__